<template>
    <template v-if="!summaryMode">
        <div class="discountContainer fluid-table-row clearfix" v-show="Cart.Discount > 0">
            <div class="discountlabel col-md-8 col-sm-8 col-xs-8">{{getInterfaceText('shop_discount')}}<span v-show="!Cart.Coupon">: {{Cart.DiscountName}}</span></div>
            <div class="discountlabel col-md-4 col-sm-4 col-xs-4 text-right">- <span class="cart-discount">{{Cart.DiscountToFormat}}</span></div>
        </div>
        <div class="fluid-table-row clearfix" v-show="Cart.ShippingType != 'giftcard'">
            <div class="col-md-8 col-sm-8 col-xs-8">
                {{getInterfaceText('shop_shippingcosts')}} <span id="shippingLabel">- {{Cart.ShippingName}}</span>
                <p v-show="Cart.ShippingLabel && Cart.ShippingLabel.length > 0" class="shipping-label">({{Cart.ShippingLabel}})</p>
                <p v-show="Cart.ShippingExtra && Cart.ShippingExtra.length > 0" class="shipping-extra"><a data-toggle="modal" data-target="#preOrderModal" style="cursor:pointer;"><i class="glyphicon glyphicon-new-window" aria-hidden="true"></i> {{Cart.ShippingExtra}}</a></p>
            </div>
            <div class="col-md-4 col-sm-4 col-xs-4 text-right">
                <span class="shipping-total">{{Cart.ShippingCosts_FreightAmountToFormat}}</span>
            </div>
        </div>
        <div class="fluid-table-row clearfix" v-show="Cart.ShippingCosts_OrderHandlingAmountToFormat != null">
            <div class="col-md-8 col-sm-8 col-xs-8">
                {{getInterfaceText('shop_orderhandlingcosts')}}
                <button v-if="getInterfaceText('shop_orderhandlingCosts_explanation').length > 0" data-toggle="modal" data-target="#orderhandlingModal" style="cursor: pointer; color: inherit; border: none; background: none;"><i class="glyphicon glyphicon-question-sign" aria-hidden="true"></i><span class="sr-only">Open Destination Fee explanation</span></button>
            </div>
            <div class="col-md-4 col-sm-4 col-xs-4 text-right">
                <span class="shipping-total">{{Cart.ShippingCosts_OrderHandlingAmountToFormat}}</span>
            </div>
        </div>
        <div class="fluid-table-row clearfix" v-if="ProductPriceExcludedTax == true">
            <div class="col-md-6 col-sm-6 col-xs-6">{{getInterfaceText('shop_tax')}}</div>
            <div class="col-md-6 col-sm-6 col-xs-6 text-right"><span class="cart-tax">{{Cart.TaxToFormat}}</span></div>
        </div>
        <div v-if="ShowGiftcardOrCouponPanel == true">
            <div class="total fluid-table-row clearfix" v-show="Cart.Giftcards && Cart.Giftcards.length > 0">
                <div class="col-md-6 col-sm-6 col-xs-6">{{getInterfaceText('shop_total_excluding_giftcards')}}</div>
                <div class="col-md-6 col-sm-6 col-xs-6 text-right">{{Cart.TotalIncludingShippingCostsExcludingGiftcardsToFormat}}</div>
            </div>
            <div class="fluid-table-row clearfix" v-show="Cart.Giftcards && Cart.Giftcards.length > 0">
                <div class="col-md-6 col-sm-6 col-xs-6">{{getInterfaceText('shop_amount_covered_by_giftcards')}}</div>
                <div class="col-md-6 col-sm-6 col-xs-6 text-right">{{Cart.GiftcardsTotalToFormat}}</div>
            </div>
        </div>
        <div class="total fluid-table-row clearfix">
            <div class="col-md-6 col-sm-6 col-xs-6">{{getInterfaceText('shop_total')}}</div>
            <div class="col-md-6 col-sm-6 col-xs-6 text-right">
                <span class="cart-total">{{Cart.TotalIncludingShippingCostsToFormat}}</span>
                <div v-if="ShowTaxInclusiveTag">
                    <br /><span style="font-size:10px;font-weight:normal;">{{getInterfaceText('shop_vat_inclusive')}}</span>
                </div>
            </div>
        </div>
    </template>
    <template v-else>
        <div class="total fluid-table-row clearfix">
            <div class="col-md-6 col-sm-6 col-xs-6 text-left">
                <span class="cart-total-label">{{getInterfaceText('shop_total')}}:</span>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-6 text-right">
                <span class="cart-total">{{Cart.TotalToFormat}}</span>
                <span v-if="ShowTaxInclusiveTag">
                    <br /><span style="font-size:10px;font-weight:normal;">{{getInterfaceText('shop_vat_inclusive')}}</span>
                </span>
            </div>
        </div>
    </template>
</template>

<script>
    import cartMixin from '../mixins/cart-mixin.js';
    import generalMixin from '../mixins/general.js';
    export default {
        name: 'cart-table',
        mixins: [cartMixin, generalMixin],
        props: ['editMode', 'summaryMode'],
        template: '#cart-totals-template',
        data: function () {
            return {
                ProductPriceExcludedTax: false,
                ShowGiftcardOrCouponPanel: false,
                ShowTaxInclusiveTag: false
            }
        },
        methods: {
            // See cartMixin
        },
        computed: {
            // See cartMixin
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-cart-parameters').dataset.interfacetexts);
            this.ProductPriceExcludedTax = document.getElementById('vue-cart-parameters').dataset.productpriceexcludedtax == 'true';
            this.ShowGiftcardOrCouponPanel = document.getElementById('vue-cart-parameters').dataset.showgiftcardorcouponpanel == 'true';
            this.ShowTaxInclusiveTag = document.getElementById('vue-cart-parameters').dataset.showtaxinclusivetag == 'true';
        }
    }
</script>
